<template>
  <div>
    <b-overlay
      id="overlay-background"
      :show="conditionLoader === true"
      variant="dark"
      opacity="0.85"
      blur="2px"
      rounded="sm"
      spinner-variant="primary"
      spinner-medium
    >
      <div
        class="alert-heading"
      >
        <span
          class="condition-head condition-head-left condition-heading-title"
        >
          <h4>
            {{ moduleObject.module_id === 9 ? 'User Action Module' :
              moduleObject.module_id === 2 ? 'Condition Module' :
              moduleObject.module_id === 17 ? 'Bailiff Conclusion Popup' :
              moduleObject.module_id === 25 ? 'Content Condition Module' :
              moduleObject.module_id === 14 ? 'Timed Condition Module' : 'Condition Module' }}
          </h4>
        </span>
        <span
          class="condition-head condition-head-right"
        >
          <b-button
            v-if="moduleObject.depends_on > 0"
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            variant="outline-primary"
            class="mr-1"
            @click="expandConditionBack(moduleObject.depends_on, mainDivId)"
          >
            {{ $t('DEBTIA_GO_BACK') }}
          </b-button>
          <b-dropdown
            v-if="userType !== 'super-admin' && moduleObject.module_id !== 9"
            v-ripple.400="'rgba(255, 159, 67, 0.15)'"
            split
            :text="$t('DEBTIA_OPTIONS_TEXT')"
            variant="outline-primary"
            class="option-btn"
            :class="moduleObject.module_id === 17 ? 'insolvens-class' : ''"
          >
            <b-dropdown-item
              v-b-modal.modal-role
              @click="addNoModule(moduleObject.id)"
            >
              {{ moduleObject.module_id === 17 ? $t('DEBTIA_ADD_NO_MODULE_BAILIFF') : $t('DEBTIA_ADD_NO_MODULE') }}
            </b-dropdown-item>
            <b-dropdown-item
              v-b-modal.modal-role
              @click="addYesModule(moduleObject.id)"
            >
              {{ moduleObject.module_id === 17 ? $t('DEBTIA_ADD_YES_MODULE_BAILIFF') : $t('DEBTIA_ADD_YES_MODULE') }}
            </b-dropdown-item>
          </b-dropdown>
        </span>
      </div>
      <condition-piece
        v-if="moduleObject.module_id !== 9"
        :ref="'conditionpiece-'+moduleObject.id"
        :module-object="moduleObject"
        :all-modules="allModules"
        :main-div-id="mainDivId"
      />
      <user-action-piece
        v-if="moduleObject.module_id === 9"
        :module-object="moduleObject"
        :button-modules="buttonModules"
        :user-action-id="moduleObject.id"
        :parent-module="parentModule"
        :active-button-id="activeButtonId"
        :main-div-id="mainDivId"
      />
    </b-overlay>
  </div>
</template>

<script>
import {
  BButton, BOverlay, BDropdown, BDropdownItem,
} from 'bootstrap-vue'
import axios from '@axios'
import Ripple from 'vue-ripple-directive'
// import { EventBus } from '@/event-bus'
// import i18n from '@/libs/i18n'
import { EventBus } from '@/event-bus'
import ConditionPiece from './ConditionPiece.vue'
import UserActionPiece from './UserActionPiece.vue'

export default {
  components: {
    BButton,
    BOverlay,
    BDropdown,
    BDropdownItem,
    ConditionPiece,
    UserActionPiece,
  },
  directives: {
    Ripple,
  },
  props: {
    apiProcessModules: {
      type: Array,
      required: true,
    },
    conditionCheck: {
      type: Boolean,
      required: true,
    },
    moduleSettings: {
      type: Object,
      required: true,
    },
    parentModule: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      activeButtonId: 0,
      conditionLoader: false,
      moduleObject: {},
      buttonModules: [],
      // previousObject: {},
      allModules: [],
      module: 0,
      modalLoaderOne: true,
      componentConditionCheck: false,
      conditionModule: true,
      processes: [],
      caseReasonOptions: [],
      userType: JSON.parse(localStorage.getItem('userData')).role[0],
      mainDivId: this.parentmodule,
    }
  },
  watch: {
  },
  created() {
    this.moduleObject = { ...this.moduleSettings }
    this.allModules = [...this.apiProcessModules]
    this.buttonModules = this.allModules.filter(element => element.depends_on === this.parentModule)
    this.parentmodule = this.parentModule
    this.mainDivId = this.parentModule
    this.getCaseReasonOptions()
  },
  methods: {
    expandfunction(obj) {
      this.conditionLoader = true
      setTimeout(() => {
        const expandedmodule = this.allModules.filter(element => element.id === obj.btnId)[0]
        this.moduleObject = expandedmodule
        if (this.moduleObject.module_id === 9) {
          // this.buttonModules = this.moduleObject.module_settings.buttons
          const arr = this.allModules.filter(element => element.depends_on === obj.btnId)
          this.buttonModules = arr
        }
        this.conditionLoader = false
      }, 2000)
    },
    turnWhite() {
      this.conditionModule = true
    },
    addNoModule(moduleID) {
      const obj = {
        parentID: this.parentmodule,
        moduleID,
        type: 0,
      }
      this.$emit('addChildModule', obj)
    },
    addYesModule(moduleID) {
      const moduleObject = {
        parentID: this.parentmodule,
        moduleID,
        type: 1,
      }
      this.$emit('addChildModule', moduleObject)
    },
    refreshModule(type = null) {
      this.activeButtonId = type
      this.conditionLoader = true
      const processID = this.$route.params.id
      const url = `/process/get/${processID}`
      axios.get(url).then(response => {
        if (response.status === 200) {
          setTimeout(() => {
            this.allModules = response.data.data.process_modules
            this.buttonModules = this.allModules.filter(element => element.depends_on === this.parentModule)
            console.log('this.moduleObject.module_id 1 ', this.moduleObject.module_id)
            if (this.moduleObject.module_id === 9) {
              this.buttonModules = this.allModules.filter(element => element.depends_on === this.moduleObject.id)
            }
            this.conditionLoader = false
          }, 2000)
        }
      })
    },
    expandConditionBack(id, main) {
      const obj = {
        id,
        main,
      }
      EventBus.$emit('refreshBack', obj)
    },
    expandCondition(id) {
      this.conditionLoader = true
      setTimeout(() => {
        const md = this.allModules
        md.forEach(element => {
          if (element.id === id) {
            this.moduleObject = element
          }
        })
        if (this.moduleObject.module_id === 9) {
          this.buttonModules = this.allModules.filter(element => element.depends_on === id)
        }
        this.conditionLoader = false
      }, 2000)
    },
    async getCaseReasonOptions() {
      const url = '/get-reason-options'
      await axios.get(url).then(response => {
        if (response.status === 200) {
          this.caseReasonOptions = response.data.data
        }
      })
    },
  },
}
</script>

<style lang="scss">
.awaitlist {
  border-radius: 10px;
}

.row-yes-no {
  margin-top: 5px;
}

.yes-no {
  text-align: center;
  color: #307772;
  font-weight: bolder;
}

.split-div .list-group-item.yes-no{
  background-color: #badcdc;
}

.split-div{
  border-radius: 5px;
  border-top: 2px solid #468783;
}

.yes-no:hover {
  text-align: center;
  color: #307772;
  font-weight: bolder;
}

.column-no {
  padding-right: 3px;
}

.column-yes {
  padding-left: 3px;
}

.condition-head {
  display: inline-block;
}

.condition-head-left {
  margin-top: 10px;
}

.condition-head-right {
  float: right;
}

.option-btn .btn.btn-outline-primary:first-child {
  padding: 10px 40px;
}

.list-group-item.main-items {
  text-align: center;
}

.condition-heading-title h4 {
  font-weight: 600;
  font-size: 1.1rem;
  color: inherit;
}

.collapse-icon.collapse-default .card .card-header {
  background-color: #f7f7f7;
}

.nested-condition-module {
  border: 1px solid #e4f2f1;
}

.nested-module {
  margin-bottom: 5px !important;
}

.expand-btn {
  width: 100%;
  margin-top: 10px;
}

.expand-feather {
  top: 0px !important;
}
.main-cols .alert .operator-list{
  position: relative;
  margin-bottom: 5rem;
  border-bottom: 2px solid #468783;
}
.main-cols .alert .operator-list:before{
  position: absolute;
  content: '';
  left: 50%;
  transform: translateX(-50%);
  top: 100%;
  height: 30px;
  width: 2px;
  background: #468783;
}
.main-cols .alert .operator-list:after{
  position: absolute;
  content: '';
  left: 50%;
  transform: translateX(-50%);
  top: 100%;
  margin: 30px 0 0;
  width: 50%;
  height: 43px;
  background: none;
  border: 2px solid #468783;
  border-bottom: none;
}

.noBackGround:hover {
  background-color: white !important;
}

.list-group-item.internal-items {
  text-align: center;
}

.card-header.collapsed .lead.collapse-title::after {
  background-image: "url(data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%236e6b7b' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-down'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E)";
}

.reminder-list-item {
  background-color: #f7f7f7;
}

.insolvens-class ul {
  left: auto !important;
  right: -70px !important;
}
</style>
